import { useContext, useState } from "react";
import TextWithCheckboxField from "../../../../components/textWithCheckboxField/textWithCheckboxField";
import KrFormContext, { KrFormContextLandslideType, NavHeadingsKROEnum, landSlideAttributes } from "../../../../contexts/krFormContext";
import { TextWithCheckBoxFieldProps } from "../../../../components/textWithCheckboxField/types/textWithCheckboxFieldProps";
import SelectForTextField from "../../../../components/selectForTextField/selectForTextField";
import { SelectForTextFieldProps } from "../../../../components/selectForTextField/types/selectForTextFieldProps";
import { styleFormFieldSeventyFive } from "../../../../components/shared/stylization";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { createConfigValidation } from "../../../../helpers/validation/validation";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";

const WorkPerformed = (props: FormSectionProps) => {

    const [pristine, setPristine] = useState(true);
    

    const checkIfHasValue = (value: string | undefined | null, name?: string) => {
        if (value !== undefined && value !== "" && value !== "Nie wykonano" && value != null) {
            return false;
        }
        return true;
    }

    const Options: Option[] = [
        { name: 'Palisada z mikropali', value: '1' },
        { name: 'Palisada z mikropali o średnicy X mm, długości X m, w rozstawie co X cm', value: '2' },
        { name: 'Palisada żelbetowa z żelbetowym oczepem, kotwiona kotwami gruntowymi', value: '3' },
        { name: 'kotwienie kotwami gruntowymi', value: '4' },
        { name: 'kotwienie kotwami gruntowymi w X rzędach, w rozstawie co X m', value: '5' },
        { name: 'odwodnienie powierzchniowe w postaci ...', value: '6' },
        { name: 'odwodnienie wgłębne w postaci drenażu francuskiego', value: '7' },
        { name: 'siatka stalowa kotwona gwoździami gruntowymi', value: '8' },
        { name: 'materace gabionowe (kosze siatkowe wypełnione kamieniami)', value: '9' },
    ]

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [safeguard, setSafeguard] = useState(checkIfHasValue(krForm.landslideAttributes?.zabezpieczeniE_OPIS, "zabezpieczeniE_OPIS"));
    const [selectedDescript, setSelectedDescript] = useState(Options[0]);
    const [description, setDescription] = useState(Options[0].name);

    const isFormNotValid = krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;

    const checkboxChange = (name: string, set: Function, state: boolean) => {
        var form: any = Object.assign({}, krForm);
        if (!state && form !== null && form.landslideAttributes) {
            form.landslideAttributes[name as keyof landSlideAttributes] = "Nie wykonano";
            form.landslideAttributes.czY_ZABEZPIECZONE = 0;
            form.landslideAttributes.tyP_ZABEZPIECZNIA_OSUWISKA_SID = 2;
            setkrForm(form);
            set(true);
        }
        else {
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                form.landslideAttributes.czY_ZABEZPIECZONE = 1;
                form.landslideAttributes.tyP_ZABEZPIECZNIA_OSUWISKA_SID = 1;
                setkrForm(form);
                set(false);
            }
        }
        setDescription(Options[0].name);
        setPristine(false);
    }

    const focusChange = (name: string, set: Function, state: boolean) => {
        if (state) {
            var form: any = Object.assign({}, krForm);
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
            }
            set(!state);
        }
    }

    // const blurChange = (event: any, name: string, set: Function, state: boolean) => {
    //     if (event.target.value == null || event.target.value === "") {
    //         var form = krForm;
    //         if (form.landslideAttributes) {
    //             if (!state) checkboxChange(name, set, state);
    //         }
    //     }
    // }
    var textWithCheckboxProps: TextWithCheckBoxFieldProps = {
        textAreaProps: {
            labelName: '',
            textAreaPlaceholder: 'Dodaj opis',
            value: krForm.landslideAttributes?.zabezpieczeniE_OPIS,
            textareaSharedProps: {
                className: 'body-txt-large',
                style: {
                    width: '100%',
                    minHeight: '70px'
                }
            },
            onFocusText: () => { focusChange("zabezpieczeniE_OPIS", setSafeguard, safeguard) },
            //onBlurText: (event: any) => { blurChange(event, "zabezpieczeniE_OPIS", setSafeguard, safeguard) },
            setValue: (value: any) => {
                var form: any = Object.assign({}, krForm);
                if (form && form.landslideAttributes) {
                    form.landslideAttributes.zabezpieczeniE_OPIS = value;
                    setkrForm(form);
                }
            },
            configValidation: createConfigValidation("zabezpieczeniE_OPIS"),
            pristine: pristine,
            disabled: !props.editMode,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.praceZabezp_rodzajeIZakresWykonywanychPracZabezpieczajacych, "Rodzaje i zakres wykonywanych prac zabezpieczających", props.setNewCommentFieldDetails!),
            textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.praceZabezp_rodzajeIZakresWykonywanychPracZabezpieczajacych, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.praceZabezp_rodzajeIZakresWykonywanychPracZabezpieczajacych); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.praceZabezp_rodzajeIZakresWykonywanychPracZabezpieczajacych,
            dynamicResize: true,
            validationError: isFormNotValid,
        },
        checkBoxProps: {
            onChange: () => { checkboxChange("zabezpieczeniE_OPIS", setSafeguard, safeguard) },
            labelName: 'Nie wykonano',
            inputChecked: safeguard,
            disabled: !props.editMode
        }
    }

    const onClickButton: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        var form: any = Object.assign({}, krForm);
        form.landslideAttributes.zabezpieczeniE_OPIS += description;
        setkrForm(form);
        setPristine(false);
    }

    const selectOptionChange = (option: Option | Option[]) => {
        if (option) {
            const opt = option as Option;
            if (opt.name) {
                setSelectedDescript(opt);
                setDescription(opt.name);
            }
        }
    }

    const selectForTextProps: SelectForTextFieldProps = {
        selectInputProps: {
            style: styleFormFieldSeventyFive,
            label: 'Szablon',
            options: Options,
            selectedSingleOption: selectedDescript,
            onChange: selectOptionChange
        },
        buttonProps: {
            BtnProps: {
                onClick: onClickButton,
                className: classNameBtn.SmallSecondary + " body-txt-medium",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                }
            },
            placeHolder: "Dodaj treść z szablonu",
            placeHolderStyle: {
                paddingLeft: '25px'
            },
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '28%',
                    display: 'flex',
                    height: '49px',
                    paddingTop: '30.5px'
                }
            }
        }
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.WorkPerformed, props.getMapForNavScroll!)}>11. Rodzaje i zakres wykonywanych prac zabezpieczających</h2>
            <TextWithCheckboxField {...textWithCheckboxProps} />
            {!safeguard && props.editMode ? (<SelectForTextField {...selectForTextProps} />) : null}
        </>
    )
}

export default WorkPerformed;